/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { useAmp } from 'next/amp';

const Loading = ({ mobile, desktop }) => {
  const { isMobile } = useDeviceScreen();
  const isAmp = useAmp();
  const width = (isAmp || isMobile) ? mobile.width : desktop.width;
  const height = (isAmp || isMobile) ? mobile.height : desktop.height;

  return !isMobile ? (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="50" y="15" rx="0" ry="5" width="224" height="20" />
      <rect x="1" y="66" rx="0" ry="0" width="320" height="150" />
      <rect x="1" y="240" rx="0" ry="0" width="230" height="12" />
      <rect x="1" y="265" rx="0" ry="0" width="320" height="22" />
      <rect x="1" y="315" rx="0" ry="0" width="320" height="150" />
      <rect x="1" y="489" rx="0" ry="0" width="230" height="12" />
      <rect x="1" y="514" rx="0" ry="0" width="320" height="22" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="50" y="15" rx="0" ry="5" width="224" height="20" />
      <rect x="1" y="66" rx="0" ry="0" width="320" height="150" />
      <rect x="1" y="240" rx="0" ry="0" width="230" height="12" />
      <rect x="1" y="265" rx="0" ry="0" width="320" height="22" />
      <rect x="1" y="315" rx="0" ry="0" width="320" height="150" />
      <rect x="1" y="489" rx="0" ry="0" width="230" height="12" />
      <rect x="1" y="514" rx="0" ry="0" width="320" height="22" />
    </ContentLoader>
  );
};

Loading.propTypes = {
  mobile: PropTypes.object,
  desktop: PropTypes.object,
};

export default Loading;
